const Trophy = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3499_19939)">
      <path
        d="M9 11.25C6.51472 11.25 4.5 9.23528 4.5 6.75V2.58333C4.5 2.27295 4.5 2.11775 4.54523 1.99348C4.62105 1.78516 4.78516 1.62105 4.99348 1.54523C5.11775 1.5 5.27295 1.5 5.58333 1.5H12.4167C12.7271 1.5 12.8822 1.5 13.0065 1.54523C13.2148 1.62105 13.3789 1.78516 13.4548 1.99348C13.5 2.11775 13.5 2.27295 13.5 2.58333V6.75C13.5 9.23528 11.4853 11.25 9 11.25ZM9 11.25V13.5M13.5 3H15.375C15.7245 3 15.8992 3 16.037 3.05709C16.2208 3.13321 16.3668 3.27922 16.4429 3.46299C16.5 3.60082 16.5 3.77554 16.5 4.125V4.5C16.5 5.19748 16.5 5.54622 16.4233 5.83234C16.2153 6.6088 15.6088 7.21528 14.8323 7.42333C14.5462 7.5 14.1975 7.5 13.5 7.5M4.5 3H2.625C2.27554 3 2.10082 3 1.96299 3.05709C1.77922 3.13321 1.63321 3.27922 1.55709 3.46299C1.5 3.60082 1.5 3.77554 1.5 4.125V4.5C1.5 5.19748 1.5 5.54622 1.57667 5.83234C1.78472 6.6088 2.3912 7.21528 3.16766 7.42333C3.45378 7.5 3.80252 7.5 4.5 7.5M5.58333 16.5H12.4167C12.6008 16.5 12.75 16.3508 12.75 16.1667C12.75 14.6939 11.5561 13.5 10.0833 13.5H7.91667C6.44391 13.5 5.25 14.6939 5.25 16.1667C5.25 16.3508 5.39924 16.5 5.58333 16.5Z"
        stroke="#535862"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3499_19939">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Trophy;
